import { ImageAttachmentPicker, type ImageAttachmentPickerProps } from '@wapharma/design-system';

/** Thin wrapper — logic lives in design-system ImageAttachmentPicker. */
export type SupportTicketAttachmentPickerProps = ImageAttachmentPickerProps;

export function SupportTicketAttachmentPicker(props: ImageAttachmentPickerProps) {
  return <ImageAttachmentPicker {...props} />;
}
